import React, { Component } from 'react';
import Constants from '../../Config/Config';
import {roundToTwo} from '../../Helpers/Helpers';

class Shipping extends Component {

	constructor(props) {
        super(props);
        this.state = {
			qtyError: false
        }
    }

	onChange = (e) => {
		var qValue = e.target.value;
		if (qValue !== '') {
			qValue = Math.ceil(qValue);
			if (parseFloat(qValue) <= 0)
				qValue = 1;
		}
		if (parseFloat(qValue) > Constants.MAX_QTY) {
			this.setState({ qtyError: true })
		} else {
			this.props.dispatch({
	            type: 'SET_STATE',
	            state: {
	                qty: qValue
	            }
	        });
	        this.setState({ qtyError: false })
		}
	}

	getCartTotal = () =>  {
		const {canvasFrameTotal, stretchingTotal} = this.props;

	    var output = parseFloat(canvasFrameTotal) + parseFloat(stretchingTotal);

	    this.props.dispatch({
			type: 'SET_STATE',
			state: {
				cart1ItemTotal: output.toFixed(2)
			}
		})
	}

	componentDidUpdate(prevProps, prevState) {
	    if (prevProps.frameTotal !== this.props.frameTotal || prevProps.qty !== this.props.qty || prevProps.canvasFrameTotal !== this.props.canvasFrameTotal || prevProps.stretchingTotal !== this.props.stretchingTotal) {
	      	this.getCartTotal();
	  	}
	}

  	render() {
  		const {qty, cart1ItemTotal} = this.props;
	    return (
	    	<>
		        <div className="cont_rgt_qty">
					<ul>
						<li>
							<label>Quantity:</label>
							<div className="quantity">
								<input type="number" name="qty" value={qty} onChange={this.onChange} className={qty === '' ? "image-size-error" : ""} />
							</div>
						</li>
						<li className="cart-total">
							<p>Total: <span>{Constants.Currency + roundToTwo(cart1ItemTotal * qty)}</span></p>
						</li>
					</ul>
				</div>
				{this.state.qtyError &&
					<div className="alert alert-info m-b-5">
						Max allowed quantity is {Constants.MAX_QTY}. Please email us to obtain a quote for greater quantity.
					</div>
				}
			</>
	    );
  	}
}

export default Shipping;